import React from "react";
import './style.less';
import {Image} from "antd";

export default class TrainingContent extends React.Component{
    render() {
        return (
            <div className={'training-content'}>
                <div className="block">
                    <p>全面的飞行培训服务</p>
                    <h1>" 始于训练，忠于安全 "</h1>
                    <h4>力动几何针对无人机产品和解决方案提供系统化和层次化的专业培训服务，包含了航线规划和数据采集等基础知识，以及针对特定行业应用的培训。<br></br>帮助客户学习如何正确使用无人机，以及如何进行维护以使其保持最佳工作状态。
                    </h4>
                <div className="image">

                </div>
                <h3>
                        <span>14</span> 天无人机实操培训<br/>
                        <span>7</span> 天无人机模拟器培训
                </h3>
                </div>
            </div>
        )
        }
    }
